import { useCallback, useState } from 'react';

interface UseEmojiPickerReturn {
  isOpen: boolean;
  openPicker: () => void;
  closePicker: () => void;
  togglePicker: () => void;
}

/**
 * Hook to manage emoji picker state.
 * Provides a clean interface for controlling the emoji picker visibility.
 *
 * Benefits:
 * - Removes DOM dependencies
 * - Makes testing easier
 * - Provides a consistent API
 * - Allows for future enhancements (e.g., positioning, animations)
 *
 * @returns Interface for controlling the emoji picker
 */
export function useEmojiPicker(): UseEmojiPickerReturn {
  const [isOpen, setIsOpen] = useState(false);

  const openPicker = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closePicker = useCallback(() => {
    setIsOpen(false);
  }, []);

  const togglePicker = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    openPicker,
    closePicker,
    togglePicker
  };
}
